import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  gap: 1rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;
  height: 5rem;
  font-size: 1.2rem !important;
`
